export default {
  policyFileNotFound: 'Policy File Not Found',
  policyFileNotFoundDescription:
    'The requested policy document could not be found. Please contact support if you believe this is an error.',
  goToHome: 'Go to Home',
} as const
